import Util from '../../Common/Util';

export default class AutoComplete {
    constructor() {
        this.idList = []; // <input> id 리스트
        this.onSelectList = []; // onSelect 함수 리스트
        this.onRenderList = []; // onRender 함수 리스트
        this.onEnterList = []; // onEnter 함수 리스트
        this.onFindList = []; // onFind 함수 리스트
        this.ulSuffix = '-ul-autocomplete';
        this.option = [];
        this.valueKey = 'data-name';
        // ⚠️ 인덱스/마지막검색어는 반드시 인풋별로 따로 들고 있어야 한다.
        // 이 클래스는 $j.F.Admin.AutoComplete 싱글턴이라 한 화면의 여러 인풋(발주자명·수주자명·
        // 신규접수)이 같은 인스턴스를 쓴다. 예전엔 이 둘이 인스턴스 공유값이라
        //  - 같은 키워드를 두번째 인풋에 치면 lastKeyword 가 같아 목록이 아예 안 떴고
        //  - 한 인풋에서 방향키로 옮긴 nowIndex 가 다른 인풋의 엔터 처리를 막았다.
        this.nowIndexMap = {};  // id → 현재 선택된 리스트 항목의 인덱스
        this.lastKeyword = {};  // id → 가장 마지막으로 ajax 로 요청한 키워드
        this.extraParams = {};  // id → 요청에 덧붙일 파라미터
    }

    /** 해당 인풋의 리스트 선택 인덱스 (미선택 -1) */
    getIndex = function (id) {
        const n = this.nowIndexMap[id];
        return n === undefined ? -1 : n;
    }

    /** 해당 인풋의 리스트 선택 인덱스 세팅 */
    setIndex = function (id, n) {
        this.nowIndexMap[id] = n;
    }

    /**
     * 특정 입력 필드와 연결 초기화
     * @param {string} id - 입력 필드의 ID
     * @param v <input> 의 value
     * @param d <input> 의 data-value
     */
    init = function (option) {
        const {
            id = '',         // 필수값이므로 기본값으로 빈 문자열
            v = '',          // 초기 value가 없으면 빈 문자열
            d = '',          // data-value가 없으면 빈 문자열
            onSelect = null,  // onSelect이 없으면 null로 설정
            onRender = null,// onRender이 없으면 null로 설정
            onEnter = null,// onEnter이 없으면 null로 설정
            onFind = null,// onFind이 없으면 null로 설정
            params = null,// 자동완성 요청에 덧붙일 파라미터 (예: {withSosok: 1}). 없으면 kwd 만 보낸다
        } = option;

        this.extraParams[id] = params;

        this.updateFn(id, onSelect, onRender, onEnter, onFind);

        if (!this.idList.includes(id)) this.idList.push(id);
        // 브라우저 자동완성 끄기 — `autocomplete="off"` 만으로는 **크롬이 무시한다.**
        // 이름·전화 같은 칸은 크롬이 저장값 드롭다운을 자체 판단으로 띄우는데,
        // 우리 자동완성 목록과 겹쳐 떠서 고르기가 불편했다.
        // 표준에 없는 토큰(`new-password`)을 주면 크롬이 판단을 포기한다 — 이게 유일하게 통한다.
        // data-lpignore / data-form-type 은 LastPass · 1Password 용.
        $('#' + id).attr({ autocomplete: 'new-password', 'data-lpignore': 'true', 'data-form-type': 'other' });
        $('#' + id).data('value', d).val(v);

        // ⚠ 목록 <ul> 은 인풋 옆이 아니라 **`<body>` 직속**에 둔다.
        //
        //   모달 안에서 쓰면 인풋 옆에 둘 수 없다. `.ui-modal` 은 `overflow: hidden` 이라
        //   목록이 잘리고, `.ui-modal--center` 는 `transform` 을 갖는데 **변형된 조상이 있으면
        //   `position: fixed` 가 화면이 아니라 그 조상 기준으로 잡힌다.** 그래서
        //   updateListPosition 이 계산한 화면좌표가 모달 위치만큼 어긋난다.
        //   (지금까지 이 자동완성은 일반 페이지에서만 써서 드러나지 않았다 —
        //    소속자로 이전 모달이 첫 모달 사용처다.)
        //
        //   다시 열 때 옛 목록이 남아 **id 가 겹치므로** 먼저 지운다. 예전에는 목록이 인풋
        //   옆이라 모달과 함께 사라졌지만, body 로 옮기면 모달이 닫혀도 남는다.
        //   z-index 1060 은 모달 패널(1055) 위다 — 인풋 옆에 있을 땐 모달 안이라 신경 쓸 일이
        //   없었지만, body 로 나오면 모달보다 위에 서야 보인다.
        $(`#${id}${this.ulSuffix}`).remove();
        $('body').append(
            `<ul id="${id}${this.ulSuffix}" class="ac-list-group"`
            + ` style="display:none; position:fixed; z-index:1060"></ul>`
        );

        this.initEvents(id); // 이벤트 바인딩
        this.bindReposition(); // 스크롤·리사이즈 추종 (싱글턴이라 한 번만 붙는다)
    }

    /**
     * <ul> 에서 <input> 과 동일한 아이템을 찾는함수
     * @param id
     * @param $liList <li>목록
     * @returns {boolean}
     */
    onFind = function(id, $liList){
        const $input = $(`#${id}`);
        const value = $input.val().trim(); // 입력된 값 (공백 제거)
        $liList.each(function () {
            const $li = $(this);
            if ($li.data('name') === value) {
                $input.data('value', $li.data('num')); // data-value 업데이트
                return true; // 반복 종료
            }
        });
        return false;
    }

    /**
     * <li> 를 선택(엔터키,클릭)시에 동작하는 기본함수
     *  init 함수에서 필요에 따라 다른 함수로 대체할수있다.
     * @param id <ul> 의 id 값
     * @param $li 선택된 li
     */
    onSelect = function (id, $li) {
        $(`#${id}`).val($li.data('name')).data('value', $li.data('num'));
    }
    /**
     * <input> 에서 엔터를 쳤을때
     * @param id
     */
    onEnter = function(id){
    }

    /**
     * <li> 한줄을 그린다.
     * @param row 데이터 row
     */
    onRender = function (row) {
        // console.log(row);
        const tpl = `<li class="ac-list-group-item" data-num="{num}" data-name="{mem_name}">{card}{num} {mem_name}</li>`;
        // 제재 딱지 — 경고만 그리던 것을 캐시 등급 전체로 넓혔다 (0정상/1경고/2차단/3환원)
        row['card'] = $j.F.Admin.Util.penaltyCard(row['penalty']);
        return Util.render_template(tpl, row);
    }

    /**
     * 이벤트 초기화
     * @param id
     */
    initEvents = function (id) {
        const self = this;
        let typingTimer; // 타이머 변수

        $(`#${id}`).on('blur', (e) => {
            // 클릭 이벤트 처리가 완료된 후 엔터 이벤트
            setTimeout(() => {
                // 리스트 클릭이 아닌 경우에만
                if (!$(e.relatedTarget).closest(`#${id}${self.ulSuffix}`).length) {
                    // console.log('id', id);
                    self.enter(id);
                }
            }, 200);
        });

        // 리스트 외 영역 클릭 시 모든 리스트 숨기기.
        // ⚠ 이름공간을 주고 먼저 끊는다 — init 이 불릴 때마다(모달을 열 때마다) 핸들러가
        //   body 에 쌓여, 열었다 닫기를 반복하면 클릭 한 번에 hideAll 이 여러 번 돌았다.
        $('body').off('click.ac').on('click.ac', () => self.hideAll());

        // 인풋 포커스 및 클릭 시
        $(`#${id}`).on('focus click', function () {
            // 새로운 인풋이 클릭되면 기존 리스트를 숨김
            self.hideAll();
        });

        // **키보드 입력 이벤트**
        $(`#${id}`).on('keydown', (event) => {
            if (event.key === 'Enter' && self.getIndex(id) === -1) {
                event.preventDefault();
                self.enter(id); // 엔터키 처리
            }
            self.handleKeyDown(id, event)
        });

        // 입력값이 변경되었을 때만 동작
        $(`#${id}`).on('input', function () {
            clearTimeout(typingTimer); // 기존 타이머 제거
            const keyword = $(this).val(); // 입력된 키워드 가져오기

            if (keyword.trim() === '') {
                // 입력값이 비어있으면 data-value 초기화
                $(this).data('value', '');
            }
            typingTimer = setTimeout(() => {
                self.fetchList(id, keyword);
            }, G5['DEBOUNCE_TIME']);
        });
        // 리스트 항목 클릭 이벤트
        $(`#${id}${this.ulSuffix}`).on('click', '.ac-list-group-item', function (e) {
            const index = $(this).index(); // 클릭된 항목의 인덱스
            // console.log('idselect');
            self.handleSelectItem(id, index);
            self.hideList(id); // 선택 후 리스트 숨기기
            e.stopPropagation(); // 이벤트 버블링 방지
        });
    }
    /**
     * onSelect, onRender가 function이 아니라면 null
     * @param id - 입력 필드의 ID
     * @param fn1 - onSelect 함수
     * @param fn2 - onRender 함수
     */
    updateFn = function (id, fn1, fn2, fn3, fn4) {
        if (typeof fn1 === 'function') this.onSelectList[id] = fn1;
        else this.onSelectList[id] = null;

        if (typeof fn2 === 'function') this.onRenderList[id] = fn2;
        else this.onRenderList[id] = null;

        if (typeof fn3 === 'function') this.onEnterList[id] = fn3;
        else this.onEnterList[id] = null;

        if (typeof fn4 === 'function') this.onFindList[id] = fn4;
        else this.onFindList[id] = null;
    }

    /**
     * 선택된 select의 fn 가져오기
     * @param id - 입력 필드의 ID
     * @returns {*}
     */
    getSelectFn = function (id) {
        let selectFn = this.onSelectList[id];

        if (typeof selectFn != 'function') {
            selectFn = this.onSelect;
        }
        return selectFn;
    }

    /**
     * data-value 의 값을 가져온다.
     * @param id - 입력 필드의 ID
     * @returns {*|jQuery}
     */
    getData = function (id) {
        // console.log('getdata');
        // console.log(id, $('#' + id).data('value'));
        let d = $('#' + id).data('value');
        if (!d) {
            d = ''
        }
        return d;
    }

    /**
     * 리스트 중 선택 시 해당 함수 불러오기
     * @param $li
     */
    select = function ($li) {
        const self = this;
        let id = $li.parent().attr('id');
        id = id.replace(self.ulSuffix, '');

        const onSelect = this.getSelectFn(id);
        onSelect(id, $li);
        // 선택 후 onSelect 가 인풋값을 프로그램적으로 비우는 경우(input 이벤트 미발생)가 많아,
        // lastKeyword 도 함께 비워둬야 다음에 같은 이름을 다시 검색했을 때 캐시에 걸리지 않는다.
        self.lastKeyword[id] = '';
        self.hideAll();
    }

    /**
     * 주어진 키워드에 따라 ajax로 데이터 조회
     * //TODO 추후 api 주소 유동적 변경
     * @param keyword 검색어
     */
    fetchList = function (id, keyword) {
        if (keyword.length < 2) {
            // ⚠️ 비워야 한다. 안 그러면 "이재일" 검색 → 선택(또는 지움) → 다시 "이재일" 일 때
            // lastKeyword 캐시가 그대로 남아 있어 목록이 영영 안 뜬다 (지운 사이 요청이 없었는데도).
            this.lastKeyword[id] = '';
            this.hideList(id);
            return;
        }
        if(this.lastKeyword[id] === keyword) return; // 같은 인풋에서 검색어 변경이 없다면 스킵
        this.lastKeyword[id] = keyword; // 요청하기전에 검색어 저장
        this.hideList(id);
        this.setIndex(id, -1);
        $.ajax({
            url: "/adm/ajax/member/find/autoComplete",
            type: 'get',
            dataType: 'json',
            data: Object.assign({kwd: keyword}, this.extraParams[id] || {}),
            success: (data) => {
                // console.log('AJAX 성공', data);
                if (data.length === 0) {
                    // console.log('데이터 없음');
                    this.hideList(id);
                } else {
                    this.renderList(id, data);
                }
            },
            // error: (xhr, status, error) => {
            //     console.error('AJAX 에러:', error);
            //     this.hideList(id);
            // },
        });
    }

    /**
     * 선택된 renderlist의 fn 가져오기
     * @param id - 입력 필드의 ID
     * @returns {*}
     */

    getRender = function (id) {
        let renderFn = this.onRenderList[id];
        if (typeof renderFn != 'function') {
            renderFn = this.onRender;
        }
        return renderFn;
    }
    /**
     * 리스트 렌더링 및 위치 업데이트
     * @param id - 입력 필드의 ID
     * @param list 검색결과 리스트
     */
    renderList = function (id, list) {
        const onRender = this.getRender(id);
        let html = '';
        // onRender 는 모두 render_template 로 값을 그대로 꽂는다 — 회원명·전화 같은 문자열은 여기서 한 번 이스케이프해 넘긴다.
        // (사본을 넘긴다. onRender 가 덧붙이는 마크업(card 등)은 그 뒤에 들어가므로 영향 없다)
        list.forEach(row => {
            const safe = {};
            Object.keys(row || {}).forEach((k) => {
                safe[k] = typeof row[k] === 'string' ? Util.escapeHtml(row[k]) : row[k];
            });
            html += onRender(safe);
        });

        // 리스트 업데이트
        $(`#${id}${this.ulSuffix}`).html(html).show();
        this.updateListPosition(id);
    }



    /**
     * 리스트의 위치, 크기 조정 — **뷰포트 기준(fixed)**.
     *
     * 전에는 `position:absolute` + `$.position()`(문서좌표)였다. 그러면 인풋이 **가로로 스크롤되는
     * 상자** 안에 있을 때 목록이 인풋에서 떨어진다 — `$.position()` 은 조상의 scrollLeft 를 반영하지
     * 않기 때문이다. 접수(/adm/orders)의 검색필터가 좁은 화면에서 그런 상자가 됐다
     * (sass pages/_order-list-legacy.scss #orderFilterScroll). 절대배치는 그런 상자에 잘리기도 한다.
     *
     * getBoundingClientRect 는 조상 스크롤이 모두 반영된 실제 화면좌표라 어디에 놓이든 맞는다.
     * 대신 화면좌표라 조상이 스크롤되면 따라 움직여야 한다 → repositionOpen()
     */
    updateListPosition = function (id) {
        const el = document.getElementById(id);
        if (!el) return;

        const r = el.getBoundingClientRect();
        const minWidth = 180; // 최소 너비(px)

        $(`#${id}${this.ulSuffix}`).css({
            position: 'fixed',
            top: r.bottom + 6,
            left: r.left,
            width: r.width < minWidth ? `${minWidth}px` : `${r.width}px`,
            display: 'block',
        });
    }

    /**
     * 열려 있는 목록을 인풋에 다시 맞춘다.
     * 화면좌표로 붙어 있으므로 페이지든 안쪽 스크롤 상자든 움직이면 다시 재야 한다.
     * scroll 은 버블링하지 않아 **캡처**로 받는다 (필터 상자 같은 내부 스크롤까지 잡으려고).
     */
    repositionOpen = function () {
        this.idList.forEach((id) => {
            const $ul = $(`#${id}${this.ulSuffix}`);
            if ($ul.length && $ul.is(':visible')) this.updateListPosition(id);
        });
    }

    /** repositionOpen 을 스크롤·리사이즈에 물린다 (싱글턴이라 한 번만) */
    bindReposition = function () {
        if (this._repositionBound) return;
        this._repositionBound = true;

        const on = () => this.repositionOpen();
        document.addEventListener('scroll', on, true);
        window.addEventListener('resize', on);
    }

    /**
     * 리스트 활성화 항목 표시
     */
    updateActiveItem = function (id) {
        const listItems = $(`#${id}${this.ulSuffix}`).find('.ac-list-group-item');
        listItems.removeClass('active'); // 모든 항목의 활성화 클래스 제거

        if (this.getIndex(id) >= 0) {
            const $activeItem = $(listItems[this.getIndex(id)]).addClass('active'); // 현재 항목에 활성화 클래스 추가

            // 활성화된 항목이 보이도록 스크롤 조정
            const listHeight = $(`#${id}${this.ulSuffix}`).height();
            const itemOffset = $activeItem.position().top;
            const scrollTop = $(`#${id}${this.ulSuffix}`).scrollTop();

            if (itemOffset < 0) {
                $(`#${id}${this.ulSuffix}`).scrollTop(scrollTop + itemOffset);
            } else if (itemOffset + $activeItem.outerHeight() > listHeight) {
                $(`#${id}${this.ulSuffix}`).scrollTop(scrollTop + itemOffset - listHeight + $activeItem.outerHeight());
            }
        }
    }
    /**
     * 항목 선택 처리
     * @param id - 입력 필드의 ID
     * @param index - select index
     */
    handleSelectItem = function (id, index) {
        // console.log('handle',{id, index})
        const listItems = $(`#${id}${this.ulSuffix}`).find('.ac-list-group-item');
        const selectedItem = $(listItems[index]);
        // const value = selectedItem.data('value');
        // console.log('handleselect')
        // console.log(this.onSelectList, id);
        this.select(selectedItem);

    }

    /**
     * 키보드 입력 시 동작
     * @param id - 입력 필드의 ID
     * @param event - 동작 이벤트
     */
    handleKeyDown = function (id, event) {
        if (event.isComposing || event.keyCode === 229) return;

        const self = this;
        const listItems = $(`#${id}${this.ulSuffix}`).find('.ac-list-group-item');
        const listLength = listItems.length;

        if (listLength === 0) return;
        switch (event.key) {
            case 'ArrowDown': // 아래 방향키
                event.preventDefault();
                this.setIndex(id, (this.getIndex(id) + 1) % listLength);
                this.updateActiveItem(id);
                break;


            case 'ArrowUp': // 위 방향키
                event.preventDefault();
                this.setIndex(id, (this.getIndex(id) - 1 + listLength) % listLength);
                this.updateActiveItem(id);
                break;

            case 'Enter': // 엔터키
                event.preventDefault();
                if (this.getIndex(id) >= 0) {
                    this.handleSelectItem(id, this.getIndex(id)); // 현재 선택된 항목 처리
                } else {
                    this.enter(id); // 입력된 값 처리
                }
                break;
            default:
                break;
        }
    }

    /**
     * 전체 <ul> 을 숨기기
     */
    hideAll = function () {
        const self = this;
        $.each(self.idList, function (idx, id) {
            $(`#${id}${self.ulSuffix}`).hide();
            self.setIndex(id, -1); // 선택된 항목 초기화
        });
    }
    hideList = function(id){
        $(`#${id}${this.ulSuffix}`).hide();
    }

    /**
     * 선택된 enter의 fn 가져오기
     * @param id
     * @returns {*}
     */
    getFind = function (id) {
        let fn = this.onFindList[id];
        if (typeof fn != 'function') {
            fn = this.onFind;
        }
        return fn;
    }
    /**
     * 선택된 enter의 fn 가져오기
     * @param id
     * @returns {*}
     */
    getEnter = function (id) {
        let enterFn = this.onEnterList[id];
        if (typeof enterFn != 'function') {
            enterFn = this.onEnter;
        }
        return enterFn;
    }
    /**
     * TODO 빈값이 들어가거나 data-value가 없을 시 동작, 있을 시 동작 , 리스트에 없는 값을 검색 못하게 하기
     * @param id - 입력 필드의 ID
     * @param res - 1 올바른 값, 0 잘못된 값
     */
    enter = function (id) {
        const $listItems = $(`#${id}${this.ulSuffix}`).find('.ac-list-group-item'); // 리스트 항목
        const onEnter = this.getEnter(id);
        const onFind = this.getFind(id);

        onFind(id, $listItems);
        onEnter(id);

        this.hideAll();
    }
}
